import React from "react";
import { useDotNet } from "@src/services/useDotNet";
import { TerraIncognita } from "@src/types/client";
import { Button, CircularProgress, Paper, Stack, Typography } from "@mui/material";

// import dotnetUrl from "../../../../public/wasm/_framework/dotnet.js?url";\
// import dotnetUrl from "../../../../public/wasm/_framework?url";

const dotnetUrl = import.meta.env.MODE === "development"
    ? "/public/wasm/_framework/dotnet.js"
    : "/wasm/_framework/dotnet.js";

type Assembly = {
    TerraIncognita: typeof TerraIncognita,
};

const NativeSandboxPage: React.FC = () => {

    const { assembly, loading } = useDotNet<Assembly>(dotnetUrl);
    React.useEffect(
        () => {
            console.log(assembly);
        },
        [assembly]
    );

    const fileSelected = React.useCallback<React.ChangeEventHandler<HTMLInputElement>>(
        async (e) => {
            if (assembly === null) {
                return;
            }

            if (e.target instanceof HTMLInputElement && e.target.files !== null) {
                const file = e.target.files[0];
                const data = new Uint8Array(await file.arrayBuffer());

                const result = await assembly.TerraIncognita.Client.FileProcessor.ProcessFile(data)

                alert(`Result: ${result}`);
            }
        },
        [assembly]
    );

    const [systemData, setSystemData] = React.useState<object | null>(null);

    const [worlds, setWorlds] = React.useState<number[]>([]);

    React.useEffect(
        () => {
            function handleTick() {
                if (assembly === null) {
                    return;
                }

                const text = assembly.TerraIncognita.Client.FileProcessor.GetSystemData();
                const obj = JSON.parse(text);
                setSystemData(obj);
            }

            const x = window.setInterval(handleTick, 100);
            return () => {
                window.clearInterval(x);
            };
        },
        [assembly]
    );

    const createWorld = React.useCallback(
        () => {
            if (assembly === null) {
                return;
            }

            const obj = assembly.TerraIncognita.Client.ObjectManager.CreateInstance("TerraIncognita.Client.World");
            setWorlds(x => [...x, obj]);
        },
        [assembly]
    );

    const disposeWorld = React.useCallback(
        (id: number) => {
            if (assembly === null) {
                return;
            }

            const result = assembly.TerraIncognita.Client.ObjectManager.DisposeInstance(id);
            if (result) {
                setWorlds(x => x.filter(x => x !== id));
            }
        },
        [assembly]
    );

    return (
        <div>
            <Stack padding={2} gap={2}>
                <Stack gap={1}>
                    <Typography variant="h4">💻 Native Sandbox</Typography>
                    {assembly !== null ? (
                        <input disabled={loading} type="file" onChange={fileSelected}></input>
                    ) : (
                        <CircularProgress />
                    )}
                </Stack>

                <Stack gap={1}>
                    <Typography variant="body2">System Data</Typography>
                    <pre>
                        {JSON.stringify(systemData, null, 2)}
                    </pre>
                </Stack>

                <Stack gap={1}>
                    <Stack direction="row">
                        <Button onClick={createWorld} variant="contained">
                            Create world
                        </Button>
                        <div style={{ flexGrow: 1 }}></div>
                    </Stack>
                    {worlds.map(x => (
                        <Paper key={x}>
                            <Stack padding={1} gap={1}>
                                <Stack padding={1} gap={1} direction="row" alignItems="center">
                                    <Typography variant="subtitle1">World #{x}</Typography>
                                    <div style={{ flexGrow: 1 }}></div>
                                    <Button
                                        variant="contained"
                                        color="error"
                                        onClick={() => {
                                            if (assembly === null) {
                                                return "null";
                                            }

                                            const result = assembly.TerraIncognita.Client.ObjectManager.InvokeMethod(x, "CreateChunk");
                                            alert(result);
                                        }}
                                    >
                                        Add chunk
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="error"
                                        onClick={() => disposeWorld(x)}
                                    >
                                        Dispose
                                    </Button>
                                </Stack>
                            </Stack>
                        </Paper>
                    ))}
                </Stack>
            </Stack>
        </div>
    );
};

export default NativeSandboxPage;